import { getCurrentLocaleCode } from "@taager/localization";

export function getLocalizedValue(
  value: any,
  defaultLocale?: "en" | "ar",
): string {
  if (typeof value === "string") {
    return value;
  }

  const locales = {
    en: value?.en || value?.englishName,
    ar: value?.ar || value?.arabicName,
  };

  return (
    locales[getCurrentLocaleCode()] ||
    (defaultLocale && locales[defaultLocale]) ||
    ""
  );
}
